<template>
  <tr>
    <td>
      {{item.id}}
    </td>
    <td>
      <case-service-log-event :event="item.event"/>
      <div>
        <v-chip v-if="item.metadata.reportId">
          <v-tooltip bottom>
              <span slot="activator">
                Report
              </span>
            Report from DP {{item.metadata.reportId}}
          </v-tooltip>
        </v-chip>
        <v-chip v-if="item.metadata.fileId">
          <v-tooltip bottom>
              <span slot="activator">
                Report file
              </span>
            Report file from DP {{item.metadata.fileId}}
          </v-tooltip>
        </v-chip>
      </div>

      <v-chip class="chip--select-multi v-chip--small"
              v-if="item.metadata.checkedOperationId">
        <v-tooltip bottom>
                  <span slot="activator" :style="{color: getEventColor('ChangeChecked')}">
                    C
                  </span>
          Checked: {{item.metadata.checkedOperationId}}
        </v-tooltip>
      </v-chip>

      <v-chip class="chip--select-multi v-chip--small"
              v-if="item.metadata.chargedOperationId">
        <v-tooltip bottom>
                  <span slot="activator" :style="{color: getEventColor('ChangeCharged')}">
                    C
                  </span>
          Charged: {{item.metadata.chargedOperationId}}
        </v-tooltip>
      </v-chip>

      <v-chip class="chip--select-multi v-chip--small"
              v-if="item.metadata.paidOperationId">
        <v-tooltip bottom>
                  <span slot="activator" :style="{color: getEventColor('ChangePaid')}">
                    P
                  </span>
          Paid: {{item.metadata.paidOperationId}}
        </v-tooltip>
      </v-chip>
    </td>
    <td>
      <!-- for executed-->
      <v-tooltip bottom
                 v-if="item.metadata.invoiceInfo">
          <span slot="activator">
            <router-link :to="{name:'InvoicePage', params: {invoiceId: item.metadata.invoiceInfo.id}}">
              {{item.metadata.invoiceInfo.id}}
            </router-link>
          </span>
        Added at {{item.metadata.invoiceInfo.createdAt | DateWithMinutes | NoEmpty}}
      </v-tooltip>

      <!-- for checked-->
      <v-tooltip bottom
                 v-if="item.metadata.invoiceId">
          <span slot="activator">
            <router-link :to="{name:'InvoicePage', params: {invoiceId: item.metadata.invoiceId}}">
              {{item.metadata.invoiceId}}
            </router-link>
          </span>
      </v-tooltip>
    </td>
    <td>
      {{item.createdAt | DateWithMinutes | NoEmpty}}
    </td>
    <td>
      {{item.occurredAt | DateWithMinutes | NoEmpty}}

      <v-tooltip bottom>
        <slot slot="activator">
          <v-icon small v-if="item.metadata.deletingRecordId">fa-trash</v-icon>
        </slot>
        Deleted
      </v-tooltip>

      <v-tooltip bottom>
        <slot slot="activator">
          <v-icon small v-if="item.metadata.deletedRecordId">fa-recycle</v-icon>
        </slot>
        Compensation (deletion)
      </v-tooltip>

      <v-tooltip bottom>
        <slot slot="activator">
          <v-icon small v-if="item.metadata.replaceForRecordId">fa-undo</v-icon>
        </slot>
        Replace record
      </v-tooltip>
    </td>
    <td>{{item.quantityChange}}</td>
    <td>{{item.metadata.comment | NoEmpty}}</td>
    <td>
      <v-layout>
        <replace-case-service-log-form
          v-if="!item.metadata.deletingRecordId && !item.metadata.deletedRecordId"
          :case-id="caseId"
          :id="item.id"
          :current-service-id="item.serviceId"
          :current-quantity-change="item.quantityChange"/>
        <delete-case-service-log-form
          v-if="!item.metadata.deletingRecordId && !item.metadata.deletedRecordId"
          :id="item.id"
          :case-id="caseId"/>
        <modal-json-view :json-data="item.metadata">
          <template slot="header">
            Metadata
          </template>
        </modal-json-view>
      </v-layout>
    </td>
  </tr>
</template>

<script>
  import NoEmpty from '../../Filters/NoEmpty.js'
  import DateWithMinutes from '../../Filters/DateWithMinutes.js'
  import ReplaceCaseServiceLogForm from './ReplaceCaseServiceLogForm'
  import DeleteCaseServiceLogForm from './DeleteCaseServiceLogForm'
  import CaseServiceLogEvent from './CaseServiceLogEvent'
  import ModalJsonView from "../../Ui/ModalJsonView";
  import {mapState} from "vuex";
  import {getEventColor} from "./caseServiceLogUtils";

  export default {
    name: 'case-service-log-details-item',
    components: {
      DeleteCaseServiceLogForm,
      ReplaceCaseServiceLogForm,
      CaseServiceLogEvent,
      ModalJsonView
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    props: {
      caseId: {
        type: String,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        devMode: 'devMode'
      }),
    },
    methods: {
      getEventColor(event) {
        return getEventColor(event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/CaseServiceLogDetailsItem.vue